/* unplugin-vue-components disabled */import script from "./menuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./menuItem.vue?vue&type=script&setup=true&lang=ts"

import "./menuItem.vue?vue&type=style&index=0&id=60b48ce8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.108.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60b48ce8"]])

export default __exports__